import { useContext } from 'react';
import { GenericPopupContext } from '@providers/GenericPopupProvider';

const useGenericPopup = () => useContext(GenericPopupContext);

export default useGenericPopup;
